import { Button } from '~/components/ui/Button';
import { ToastMessage } from '~/components/ui/ToastMessage';
import { menuStore } from '~/lib/stores/menu';
import { SettingsPage } from '~/lib/stores/menu';

export const SecretsUpdateToast = ({ missingSecrets }: { missingSecrets: string[] }) => {
  return (
    <ToastMessage
      title="Missing secrets"
      key="missing-secrets"
      message={
        <div className="flex flex-col gap-1">
          The following secrets are used in the code but don't exist yet:
          <ul className="list-disc list-inside">
            {missingSecrets.map((secret) => (
              <li key={secret} className="whitespace-nowrap overflow-hidden" title={secret}>
                {secret}
              </li>
            ))}
          </ul>
        </div>
      }
      bottom={
        <Button
          className="w-full"
          onClick={() => {
            menuStore.openDialog({
              type: 'settings',
              initialPage: SettingsPage.Secrets,
              prefilledSecrets: missingSecrets,
            });
          }}
          size="sm"
        >
          Open secrets settings
        </Button>
      }
    />
  );
};
